import React from 'react';
import { useParams } from 'react-router-dom';
import loadable from '@loadable/component';

const PressRoomHomeLoadable = loadable(() => import('./PressRoomHome'));
const PressRoomReleaseLoadable = loadable(() => import('./PressRoomRelease'));

export default function ValidatePressRelease(): React.ReactElement {
    const { param } = useParams<{ param: string }>();
    const isNumber = param ? /^\d+$/.test(param) : false;

    if (!param || isNumber) {
        return <PressRoomHomeLoadable />;
    }

    return <PressRoomReleaseLoadable />;
}
